import Vue from 'vue/dist/vue.esm'
import template from './district_per_school_report_template.slim'
import { getUrlWithSlug, seriesDataBar, mergeCountsBar } from '../commonChartFunctions';
import chartFilterable from '../../mixins/chart_filterable';
import barChartRange from '../../mixins/bar_chart_range';

Vue.component('district_per_school_report', {
  mixins: [template, chartFilterable, barChartRange],
  props: ['school_year_label', 'year_info', 'report_date', 'section', 'templates'],
  data() {
    return {
      chartData: {},
      series: [{
        name: 'sessions',
        data: []
      }],
      chartOptions: {
        dataLabels: {
          enabled: false
        },
        chart: {
          type: 'bar',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const schoolName = config.w.config.series[0].data[config.dataPointIndex].x;
              const urlWithSlug = getUrlWithSlug(this.year_info.current_schools_year, schoolName);
              const redirectUrl = urlWithSlug + "/my_sessions";
              window.open(redirectUrl, '_blank');
            }
          }
        },
        yaxis: {
          title: {
            text: "District sessions",
            style: {
              color: '#949494'
            }
          },
          forceNiceScale: true
        },
        xaxis: {
          labels: {
            trim: true,
            rotate: -55,
          }
        },
        grid: {
          row: {
            colors: ['#FFFFFF', '#F3F3F3']
          },
          padding: {
            left: 50,
            bottom: 30
          },
        }
      }
    }
  },
  methods: {
    updateChart: function() {
      this.series = [{
        name: 'sessions',
        data: seriesDataBar(mergeCountsBar(this.chartData, this.startDate, this.endDate))
      }];
    }
  }
});
